import { render, staticRenderFns } from "./suggestionsListPopularAdder.vue.html?vue&type=template&id=58902bd5&"
import script from "./suggestionsListPopularAdder.ts?vue&type=script&lang=ts&"
export * from "./suggestionsListPopularAdder.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports